module.exports = {
          srcSet: __webpack_public_path__ + "88678574be384e9ee7afdd0ada411b60-190.png"+" 190w",
          images:[ {path: __webpack_public_path__ + "88678574be384e9ee7afdd0ada411b60-190.png",width: 190,height: 65}],
          src: __webpack_public_path__ + "88678574be384e9ee7afdd0ada411b60-190.png",
          toString:function(){return __webpack_public_path__ + "88678574be384e9ee7afdd0ada411b60-190.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAADCAYAAACqPZ51AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nC3MIQ7CUBQF0eEbkmJJioVNEESZSgwYJPQ+UF0Em0e0bnLEgHXEnDA95oDVLV17rB1mi+nA/DB3zAVzw0yYGeuBOWMNmCf4AgvGN/hp66kxTnD9blZrf36XFnV68PdlAAAAAElFTkSuQmCC",
          width: 190,
          height: 65
        }